import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { SOUNDCLOUD_UPLOAD_PARAM } from '../soundcloud/soundCloudReturnTo';

/**
 * After the SoundCloud sign-in the return page sends the artist back to this page with
 * `?soundCloudUpload=1` (design b2): the panel opens the upload dialog again, one time, and drops
 * the flag from the address.
 */
export function useUploadReturn(enabled: boolean, openUpload: () => void): void {
  const location = useLocation();
  const navigate = useNavigate();
  const done = useRef(false);
  useEffect(() => {
    if (!enabled || done.current) {
      return;
    }
    const params = new URLSearchParams(location.search);
    if (params.get(SOUNDCLOUD_UPLOAD_PARAM) !== '1') {
      return;
    }
    done.current = true;
    params.delete(SOUNDCLOUD_UPLOAD_PARAM);
    const search = params.toString();
    // eslint-disable-next-line no-void
    void navigate({ pathname: location.pathname, search: search === '' ? '' : `?${search}` }, { replace: true });
    openUpload();
  }, [enabled, location.pathname, location.search, navigate, openUpload]);
}
